/**
 * File sort-articles.js.
 *
 * Custom code to load more locations.
 *
 */

( function( $ ) {
    var ajaxurl = window.location.origin + '/wp-admin/admin-ajax.php';

    $('.article__sort').on('change', function() {
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'html',
            data: {
                action: 'sort_articles',
                category: $(this).val(),
            },
            success: function(response) {
                $('.block--sort-articles .cards').html(response);
            }
        });
    });
    
} )( window.jQuery );
